import React from 'react';
import AuthorWrapper from '../../../components/pages/authorWrapper';

import kantoj from './matveeva_kantoj';

const TKantojMatveeva = (p) => {
  const [action, store] = [p.action, p.store];
  
  return (
    <AuthorWrapper action={action} store={store} itemlist={kantoj}></AuthorWrapper>
  )
}

export default TKantojMatveeva;